  export const candidateStatusFilter = [
    {
      value: "Available",
      label: "Available",
    }, 
    {
      value: "Sourced",
      label: "Sourced",
    },         
    {
      value: "Not Picking",
      label: "Not Picking",
    },
    {
      value: "Busy",
      label: "Busy",
    },
    {
      value: "Call Later",
      label: "Call Later",
    },
    {
      value: "Not Interested",
      label: "Not Interested",
    },
    {
      value: "Not Looking",
      label: "Not Looking",
    },
    {
      value: "Not Suitable",
      label: "Not Suitable",
    },        
    {
      value: "Location Issue",
      label: "Location Issue",
    },
    {
      value: "JD Needed",
      label: "JD Needed",
    },
    {
      value: "Direct Payroll",
      label: "Direct Payroll",
    },
    {
      value: "Disconnected",
      label: "Disconnected",
    },
    {
      value: "OOS",
      label: "OOS",
    },
    {
      value: "SwitchOFF",
      label: "SwitchOFF",
    },
    {
      value: "Already Got Call",
      label: "Already Got Call",
    },
    {
      value: "Already Applied",
      label: "Already Applied",
    },
    {
      value: "Interview within 6 months",
      label: "Interview within 6 months",
    },
    {
      value: "Interview before 6 months",
      label: "Interview before 6 months",
    },
    {
      value: "To Be Called",
      label: "To Be Called",
    },
  ];

  export const resumeSuitabilityFilter = [
    { value: "Not Suitable",label: "Not Suitable"},
    { value: "Below Average", label: "Below Average" },
    { value: "Average", label: "Average" },
    { value: "Above Average", label: "Above Average" },
    { value: "Good Match", label: "Good Match" },
    { value: "Partial Suitable", label: "Partial Suitable" },
  ];
  export const resumeStatusFilter = [
    {
      value: "Shared",
      label: "Shared",
    },
    {
      value: "Review Pending",
      label: "Review Pending",
    },
    {
      value: "To Be Shared",
      label: "To Be Shared",
    },
  {
    value: "Feedback Pending",
    label: "Feedback Pending",
  },
  {
    value: "Client Feedback Pending",
    label: "Client Feedback Pending",
  },
  {
    value: "Duplicate",
    label: "Duplicate",
  },
  {
    value: "Screen Rejected",
    label: "Screen Rejected",
  },
  {
    value: "Screen Rejected HCTC",
    label: "Screen Rejected HCTC",
  },
  {
    value: "Screen Rejected HNP",
    label: "Screen Rejected HNP",
  },    
  {
    value: "Interview Rejected",
    label: "Interview Rejected",
  },
  {
    value: "Screen Selected",
    label: "Screen Selected",
  },
    {
      value: "Screen Partial Suitable",
      label: "Screen Partial Suitable",
    },  
];

export const interviewStatusFilter = [
  { value: "NA", label: "NA" },
  { value: "YTBS", label: "YTBS" },
  { value: "YTBRS", label: "YTBRS" },
  { value: "Scheduled", label: "Scheduled" },
  { value: "Rescheduled", label: "Rescheduled" },
  { value: "Cancelled", label: "Cancelled" },
  { value: "No Panel", label: "No Panel" },
  { value: "Candidate Drop", label: "Candidate Drop" },
  { value: "Candidate NP", label: "Candidate NP" },
  { value: "Panel Not Joined", label: "Panel Not Joined" },
  { value: "Candidate No Show", label: "Candidate No Show" },
  { value: "Selected", label: "Selected" },
  { value: "Candidate On Hold", label: "Candidate On Hold" },
  { value: "Rejected", label: "Rejected" },
  { value: "IFP", label: "IFP" },
  { value: "Final Select", label: "Final Select" },
];

export const offerStatusFilter = [
  { value: "Offer Pending", label: "Offer Pending" },
  { value: "Offered", label: "Offered" },
  { value: "Declined", label: "Offer Declined" },
  { value: "Joined", label: "Joined" },
  { value: "Hold", label: "Offer on Hold" },
  { value: "Accepted", label: "Offer Accepted" },
];

export const documentStatusFilter = [
  { value: "Documents Not OK", label: "Document Issues" },
  { value: "Documents OK", label: "Documents OK" },
  { value: "Documents Pending", label: "Documents Pending" },
];

export const bgvStatusFilter = [
  { value: "BGV Ongoing", label: "BGV Ongoing" },
  { value: "BGV OK", label: "BGV OK" },
  { value: "BGV Fail", label: "BGV Fail" },
];

export const parsingErrorFilter = [
  { value: "EDU_ERROR", label: "EDU_ERROR" },
  { value: "NO_ERROR", label: "NO_ERROR" },
  { value: "OCR_ERROR", label: "OCR_ERROR" },
  { value: "REF_WORD_ERROR", label: "REF_WORD_ERROR" },
  { value: "CID_ERROR", label: "CID_ERROR" },
];

export const educationAnalysisFilter = [
  { value: "Suitable", label: "Suitable" },
  { value: "Not Suitable", label: "Not Suitable" },
];

export const experienceAnalysisFilter = [
  { value: "Suitable", label: "Suitable" },
  { value: "Not Suitable", label: "Not Suitable" },
];

export const genderFilter = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

export const reasonForLeavingFilter = [
  { value: "On Bench", label: "On Bench" },
  { value: "Project Completion", label: "Project Completion" },
  { value: "LayOff", label: "LayOff" },
  { value: "Financial Growth", label: "Financial Growth" },
  { value: "No Job Satisfaction", label: "No Job Satisfaction" },
  { value: "Poor Work Environment", label: "Poor Work Environment" },
  { value: "Personal Reasons", label: "Personal Reasons" },
  { value: "To Take Care of Family", label: "To Take Care of Family" },
  { value: "Personal Health Issues", label: "Personal Health Issues" },
  { value: "Career Break", label: "Career Break" },
  { value: "Maternity Break", label: "Maternity Break" },
  { value: "Other Reasons", label: "Other Reasons" },
];

export const reasonForNotWorkingFilter = [
  { value: "NA", label: "NA"},  
  {
    value: "In Transition of Joining Another Company",
    label: "Gap before joining another company",
  },
  { value: "Personal Reasons", label: "Personal Reasons" },
  { value: "To Take Care of Family", label: "To Take Care of Family" },
  { value: "Personal Health Issues", label: "Personal Health Issues" },
  { value: "Career Break", label: "Career Break" },
  { value: "Maternity Break", label: "Maternity Break" },
  { value: "Searching Job after Education", label: "Searching Job after Education" },
  { value: "Higher Education Break", label: "Higher Education Break" },
  { value: "Competitive Exam Preperation Break", label: "Competitive Exam Preperation Break" },
  { value: "Other Reasons", label: "Other Reasons" },
];

export const otherOffersFilter = [
  { value: "No Offer", label: "No Offer" },
  { value: "One Offer", label: "One Offer" },
  { value: "Multiple Offer", label: "Multiple Offer" },
  { value: "In Pipeline", label: "In Pipeline" },
];

export const payrollFilter = [
  { value: "Our", label: "Our" },
  { value: "Client", label: "Client" },
];

export const skillMatrixSuitabilityFilter = [
  { value: "Suitable", label: "Suitable" },
  { value: "Not Suitable", label: "Not Suitable" },
];

export const assessmentSuitabilityFilter = [
  { value: "Suitable", label: "Suitable" },
  { value: "Not Suitable", label: "Not Suitable" },
];

export const interviewTypeFilter = [
  { value: "L0", label: "L0" },
  { value: "L1", label: "L1" },
  { value: "L2", label: "L2" },
  { value: "Customer", label: "Customer" },
  { value: "HR", label: "HR" },
  { value: "MgMT", label: "MgMT" },
];

export const ownershipFilter = [
    { value: "By Team", label: "Team" },
    { value: "By Vendor", label: "Vendor" },
    { value: "By Candidate", label: "NuJobs" },
    { value: "By Automation", label: "Automation" }, 
    { value: "Through Career Page", label: "Career Page" },                               
  ];
export const availableStausFilter = [
    { value: "Available",label: "Available"},
    { value: "Available HCTC", label: "Available HCTC" },
    { value: "Available HNP", label: "Available HNP" },
    { value: "Available HCTC-HNP", label: "Available HCTC-HNP" },
];
